<template>
  <div class="add-or-edit">
    <div class="content-box">
      <div class="page_title flex_between">
        <span>{{ doings_id ? "编辑活动" : "添加活动" }}</span>
        <el-button
          type="primary"
          style="width: 92px"
          @click="back"
          size="medium"
          >返回</el-button
        >
      </div>
      <div class="container">
        <div class="form-box">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
          >
            <!-- 活动信息 -->
            <h3>活动信息</h3>
            <el-form-item label="活动标题" prop="act_name">
              <el-input
                v-model="ruleForm.act_name"
                style="width: 400px"
                clearable
                placeholder="请输入"
                maxlength="10"
                :disabled="isReadonly || isNumOnlyEditable"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间" prop="activity_time">
              <el-date-picker
                v-model="ruleForm.activity_time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabled="isReadonly || isNumOnlyEditable"
                :picker-options="pickerOptions.activity"
                @change="handleActivityTimeChange"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="报名时间" prop="sign_time">
              <el-date-picker
                v-model="ruleForm.sign_time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabled="isReadonly || isNumOnlyEditable"
                :picker-options="pickerOptions.sign"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="活动地址" prop="act_address">
              <el-button
                type="primary"
                size="small"
                @click="openMapDialog"
                :disabled="isReadonly || isNumOnlyEditable"
                >选择地址</el-button
              >
              <div v-if="ruleForm.act_address" class="selected-address">
                地址： {{ ruleForm.act_address }}&nbsp;&nbsp;{{
                  ruleForm.act_long
                }},{{ ruleForm.act_lat }}
              </div>
            </el-form-item>

            <el-form-item label="活动海报" prop="act_poster">
              <UploadImg
                :f_thumb="ruleForm.act_poster"
                :f_thumb_str="ruleForm.act_poster_str"
                @emitImg="emitActPosterImg"
                :isDel="!(isReadonly || isNumOnlyEditable)"
                :key="ruleForm.act_poster"
              ></UploadImg>
              <div class="prompt">建议尺寸750*640px</div>
            </el-form-item>

            <el-form-item label="活动分享图" prop="act_image">
              <UploadImg
                :f_thumb="ruleForm.act_image"
                :f_thumb_str="ruleForm.act_image_str"
                @emitImg="emitActImg"
                :isDel="!(isReadonly || isNumOnlyEditable)"
                :key="ruleForm.act_image"
              ></UploadImg>
              <div class="prompt">建议尺寸750*640px</div>
            </el-form-item>

            <el-form-item label="活动人数" prop="act_num">
              <el-input-number
                v-model="ruleForm.act_num"
                :min="isNumOnlyEditable ? originalActNum : 1"
                :precision="0"
                :controls="false"
                :disabled="isReadonly"
              ></el-input-number>
            </el-form-item>

            <el-form-item label="需要用户填写的信息" prop="act_field">
              <el-checkbox-group
                v-model="ruleForm.act_field"
                :disabled="isReadonly || isNumOnlyEditable"
              >
                <el-checkbox label="name" name="type">姓名</el-checkbox>
                <el-checkbox label="age" name="type">年龄</el-checkbox>
                <el-checkbox label="sex" name="type">性别</el-checkbox>
                <el-checkbox label="phone" name="type">手机号</el-checkbox>
                <el-checkbox label="num" name="type">参加人数</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="活动介绍" prop="content">
              <wangeditorNew
                ref="editorBox"
                @changeCheck="changeCheck"
                :margins="margins"
                :class="{ 'editor-disabled': isReadonly || isNumOnlyEditable }"
              />
            </el-form-item>

            <div class="btn-box">
              <el-form-item>
                <el-button @click="back">取消</el-button>
                <el-button
                  type="primary"
                  @click="submitForm('ruleForm')"
                  :disabled="isReadonly"
                  >确定</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 地图 -->
    <map-dialog
      v-if="mapDialogVisible"
      ref="mapDialog"
      :visible.sync="mapDialogVisible"
      @confirm="handleMapConfirm"
    />
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "dayjs";
import activity from "@/api/activity.js";
import Pagination from "@/components/Pagination/index";
import UploadImg from "@/components/uploadImg/index";
import draggable from "vuedraggable";
import ChooseDoctor from "@/components/chooseDoctor/index";
import wangeditorNew from "../../imgtext/wangeditorNew.vue";
import MapDialog from "./MapDialog.vue";
export default {
  components: {
    Pagination,
    UploadImg,
    draggable,
    ChooseDoctor,
    wangeditorNew,
    MapDialog,
  },
  data() {
    return {
      pickerOptions: {
        // 活动时间选择器配置
        activity: {
          disabledDate: (time) => {
            // 只能选择今天及之后的日期
            return time.getTime() < Date.now() - 8.64e7; // 86400000毫秒=1天
          },
          onPick: ({ maxDate, minDate }) => {
            // 确保开始时间不晚于结束时间
            if (maxDate && minDate && minDate > maxDate) {
              this.$nextTick(() => {
                this.ruleForm.activity_time = [maxDate, minDate];
              });
            }
          },
        },
        // 报名时间选择器配置
        sign: {
          disabledDate: (time) => {
            // 只能选择今天及之后的日期
            const today = Date.now() - 8.64e7;
            if (time.getTime() < today) {
              return true;
            }

            // 如果有设置活动时间，报名结束时间不能晚于活动开始时间
            if (this.ruleForm.activity_time && this.ruleForm.activity_time[0]) {
              const activityEnd = new Date(
                this.ruleForm.activity_time[1]
              ).getTime();
              // 报名结束时间可以等于活动开始时间
              return time.getTime() > activityEnd;
            }
            return false;
          },
          onPick: ({ maxDate, minDate }) => {
            // 确保开始时间不晚于结束时间
            if (maxDate && minDate && minDate > maxDate) {
              this.$nextTick(() => {
                this.ruleForm.sign_time = [maxDate, minDate];
              });
            }
          },
        },
      },
      dialogVisible: false, // 诊疗优惠卷弹窗
      couponDiaTableLoading: false,
      doings_id: "",
      ruleForm: {
        act_name: "",
        activity_time: "",
        sign_time: "",
        act_address: "",
        act_long: "",
        act_lat: "",
        act_poster: "",
        act_poster_str: "",
        act_image: "",
        act_image_str: "",
        act_num: "",
        act_field: [],
        content: "",
      },
      originalActNum: 0, // 用于保存原始活动人数
      margins: 1,
      rules: {
        act_name: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        activity_time: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        sign_time: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        act_address: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        act_poster: [
          {
            required: true,
            message: "请上传",
          },
        ],
        act_image: [
          {
            required: true,
            message: "请上传",
          },
        ],
        act_num: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],

        content: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        act_field: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
      mapDialogVisible: false,
    };
  },
  filters: {
    couponFromText(val) {
      switch (val) {
        case 1:
          return "诊疗优惠劵";
        case 2:
          return "商城优惠券";
        case 3:
          return "诊疗优惠劵";
        case 4:
          return "诊疗优惠劵";
      }
    },
    isShareText(val) {
      switch (val) {
        case 0:
          return "不可分享";
        case 1:
          return "可分享";
      }
    },
    totalText(val) {
      switch (val) {
        case -1:
          return "无限";
        default:
          return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    isEditable() {
      return this.$route.query.status == 1; // status为1时可编辑
    },

    isNumOnlyEditable() {
      return this.$route.query.status == 2; // status为2时只能编辑act_num
    },
    isReadonly() {
      return ![1, 2, -1].includes(Number(this.$route.query.status)); // 其他情况全部只读
    },
  },
  created() {
    if (this.routeQuery.act_id != -1) {
      this.offlineActivityInfo();
    }
  },

  methods: {
    validateTimeRanges() {
      // 验证活动时间
      if (this.ruleForm.activity_time) {
        const start = this.ruleForm.activity_time[0];
        const end = this.ruleForm.activity_time[1];
        if (new Date(start) > new Date(end)) {
          this.$message.warning("活动开始时间不能晚于结束时间");
          return false;
        }
      }

      // 验证报名时间
      if (this.ruleForm.sign_time) {
        const signStart = this.ruleForm.sign_time[0];
        const signEnd = this.ruleForm.sign_time[1];

        // 报名时间自身校验
        if (new Date(signStart) > new Date(signEnd)) {
          this.$message.warning("报名开始时间不能晚于结束时间");
          return false;
        }

        // 与活动时间的关系校验
        if (this.ruleForm.activity_time && this.ruleForm.activity_time[0]) {
          const activityStart = new Date(this.ruleForm.activity_time[0]);

          // 报名结束时间可以等于活动开始时间
          if (new Date(signStart) > activityStart) {
            this.$message.warning("报名开始时间不能大于活动开始时间");
            return false;
          }
        }
      }

      return true;
    },
    // 处理活动时间变更
    handleActivityTimeChange() {
      if (this.ruleForm.sign_time && this.ruleForm.activity_time) {
        const signEnd = new Date(this.ruleForm.sign_time[1]);
        const activityStart = new Date(this.ruleForm.activity_time[0]);

        // 如果报名结束时间晚于活动开始时间，清空报名时间
        if (signEnd > activityStart) {
          this.$nextTick(() => {
            this.ruleForm.sign_time = null;
            this.$message.warning("报名结束时间不能晚于活动开始时间");
          });
        }
      }
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    emitActPosterImg(data) {
      let { path, pic } = data;
      this.ruleForm.act_poster = pic;
      this.ruleForm.act_poster_str = path;
      this.$refs["ruleForm"].validateField(["act_poster"]);
    },
    emitActImg(data) {
      let { path, pic } = data;
      this.ruleForm.act_image = pic;
      this.ruleForm.act_image_str = path;
      this.$refs["ruleForm"].validateField(["act_image"]);
    },
    // 打开地图弹窗
    openMapDialog() {
      this.mapDialogVisible = true;
    },
    // 地图信息
    handleMapConfirm(location) {
      let { address, lat, lng } = location;
      this.ruleForm.act_address = address;
      this.ruleForm.act_long = lng;
      this.ruleForm.act_lat = lat;
      this.$refs["ruleForm"].validateField(["act_address"]);
    },

    // 查询详情
    async offlineActivityInfo() {
      let params = {
        act_id: this.routeQuery.act_id,
      };
      await activity.offlineActivityInfo(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          // 保存原始活动人数
          this.originalActNum = data.info.act_num;
          this.ruleForm = _.pick(data.info, [
            "act_name",
            "act_address",
            "act_long",
            "act_lat",
            "act_poster",
            "act_poster_str",
            "act_image",
            "act_image_str",
            "act_num",
            "act_field",
            "content",
          ]);

          let start_time = dayjs
            .unix(data.info.start_time)
            .format("YYYY-MM-DD HH:mm:ss");
          let end_time = dayjs
            .unix(data.info.end_time)
            .format("YYYY-MM-DD HH:mm:ss");
          this.ruleForm.activity_time = [start_time, end_time];

          let sign_start_time = dayjs
            .unix(data.info.sign_start_time)
            .format("YYYY-MM-DD HH:mm:ss");
          let sign_end_time = dayjs
            .unix(data.info.sign_end_time)
            .format("YYYY-MM-DD HH:mm:ss");
          this.ruleForm.sign_time = [sign_start_time, sign_end_time];
          this.ruleForm.act_field = data.info.act_field.split(",");

          this.$refs.editorBox.editor.setHtml(data.info.content);
        }
      });
    },
    submitForm(formName) {
      // 验证时间关系
      if (!this.validateTimeRanges()) {
        return;
      }

      let getContent = this.$refs.editorBox.editor.getHtml();
      this.ruleForm.content = "<p><br></p>" == getContent ? "" : getContent;

      // 如果是仅可修改人数的情况(status=2)，验证人数是否大于原始值
      if (this.isNumOnlyEditable) {
        if (this.ruleForm.act_num <= this.originalActNum) {
          this.$message.warning("活动人数只能增加，不能减少");
          return;
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let interfaceName =
            this.routeQuery.act_id == -1
              ? "createOfflineActivity"
              : "updateOfflineActivityNum";

          let params =
            this.routeQuery.act_id == -1
              ? Object.assign({}, this.ruleForm)
              : Object.assign(
                  { act_id: this.routeQuery.act_id },
                  this.ruleForm
                );
          let { activity_time, sign_time } = this.ruleForm;

          params.start_time = dayjs(activity_time[0]).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          params.end_time = dayjs(activity_time[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          params.act_field = this.ruleForm.act_field.join(",");
          params.sign_start_time = dayjs(sign_time[0]).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          params.sign_end_time = dayjs(sign_time[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          );

          activity[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.back();
              }
              loading.close();
            })
            .catch((err) => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 返回
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.editor-disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
.add-or-edit {
  .map-dialog {
    .el-dialog__body {
      padding: 15px 20px;
    }
  }

  .map-container {
    position: relative;

    .search-box {
      margin-bottom: 15px;
      width: 100%;

      .el-input {
        width: 100%;
      }
    }

    .selected-location {
      margin-top: 15px;
      padding: 10px;
      background-color: #f5f7fa;
      border-radius: 4px;
      border-left: 4px solid #409eff;
      font-size: 14px;
    }
  }

  .selected-address {
    margin-top: 8px;
    padding: 8px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
  }
  .content-box {
    border-radius: 5px;
    .page_title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 24px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 18px;
      text-align: left;
      background: #fbfbfb;
      font-weight: 600;
    }
    .container {
      margin: 20px;
      box-sizing: border-box;
      background-color: #ffffff;
      min-height: calc(100vh - 140px);
      border-radius: 5px;
      padding: 20px;
      .form-box {
        text-align: left;
        h3 {
          margin-bottom: 20px;
        }
        //  border: solid 1px red;
        .form-item-flex {
          display: flex;
        }
        .head-portrait {
          img {
            width: 150px;
            height: 100px;
          }
        }
        .youhuijuan-box {
          .youhuijuan-item {
            width: 815px;
            margin-top: 10px;
            .drag-item {
              width: 150px;
              height: 120px;
              text-align: left;
              margin-right: 13px;
              margin-bottom: 13px;
              padding: 0 10px;
              box-sizing: border-box;
              background-color: #f1efef;
              position: relative;
              .el-icon-close {
                position: absolute;
                right: 5px;
                top: 5px;
                cursor: pointer;
              }
              p {
                margin: 5px 0 0 0;
                font-weight: 600;
              }
              .content {
                line-height: 24px;
              }
            }
          }
        }
        .btn-box {
          //   border:solid 1px red;
          text-align: center;
          padding-top: 30px;
        }
      }
    }
  }
  .other-config-warp {
    .other-config-box {
      text-align: left;
      height: 480px;
      padding: 30px 0 20px 0;
      border-bottom: solid 1px #ebe4e4;
    }
  }
}
.add-or-edit {
  // .el-pagination{
  //    text-align: right;
  //    margin-bottom: 30px;
  // }
  .el-form-item__content {
    height: auto;
  }
  .form-box {
    .el-form-item__content {
      height: auto;
    }

    .youhuijuan-item {
      width: 800px;
      #drag-item-box {
        //    display: flex;
        .el-icon-close {
          position: absolute;
          right: 0;
          top: 0;
          padding: 10px;
        }
      }
      #drag-item-box > div > span {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}
.cus-drainageActivity-dotor {
  width: 900px !important;
  .el-message-box__message {
    height: 400px;
    overflow-y: auto;
    p {
      .til {
        color: #f56c6c;
      }
      .box {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }
  }
}
</style>
